import React, {CSSProperties, useEffect, useRef, useState} from "react";
import {Icon} from "antd";

export interface CountDownButtonProps {
    onClick: (load: () => void, resolve: () => void, reject: () => void) => void
    text: string
    style?: CSSProperties
}

const CountDownButton: React.FC<CountDownButtonProps> = (props) => {
    const [countDown, setCountDown] = useState(0);
    const [sendCodeLoading, setSendCodeLoading] = useState(false);
    const intervalRef = useRef<any>(null);
    useEffect(() => {
        if (countDown === 60) {
            intervalRef.current = setInterval(() => {
                setCountDown(countDown => countDown - 1)
            }, 1000)
        }
        if (countDown === 0) {
            clearInterval(intervalRef.current)
            setSendCodeLoading(false)
        }
    }, [countDown])

    const onClick = () => {
        props.onClick(() => {
            setSendCodeLoading(true)
        }, () => {
            setCountDown(60)
        }, () => {
            setSendCodeLoading(false)
        });
    }
    return (
        <button type="button" className={'submit'} onClick={onClick} disabled={sendCodeLoading} style={props.style || {}}>
            {
                sendCodeLoading ? (countDown ? (countDown + 's') : (<Icon type="loading" />)) : props.text
            }
        </button>
    )
}

export default CountDownButton;
